/* global wpConfig */

import Inflector from "inflector-js";
import moment from "moment";
import Cookie from "js-cookie";
import { VueReCaptcha } from "vue-recaptcha-v3";

import {
  OverlayPlugin,
  PopoverPlugin,
  ButtonPlugin,
  ButtonGroupPlugin,
  InputGroupPlugin,
  AlertPlugin,
  LinkPlugin,
  CollapsePlugin,
  CardPlugin,
  FormCheckboxPlugin,
  DropdownPlugin,
  FormGroupPlugin,
  FormSelectPlugin,
  ToastPlugin,
  FormInputPlugin,
  FormTextareaPlugin,
  SpinnerPlugin,
  FormPlugin,
  LayoutPlugin,
  // ListGroupPlugin,
  // CardPlugin,
  // TabsPlugin,
  ModalPlugin,
  // BadgePlugin,
  FormRadioPlugin,
  NavPlugin
} from "bootstrap-vue";

import Vuelidate from "vuelidate";

export default {
  install(Vue) {
    Vue.use(FormTextareaPlugin);
    Vue.use(LayoutPlugin);
    Vue.use(FormInputPlugin);
    Vue.use(ButtonPlugin);
    Vue.use(CollapsePlugin);
    Vue.use(CardPlugin);
    Vue.use(InputGroupPlugin);
    Vue.use(ButtonGroupPlugin);
    Vue.use(AlertPlugin);
    Vue.use(OverlayPlugin);
    Vue.use(PopoverPlugin);
    Vue.use(LinkPlugin);
    Vue.use(ModalPlugin);
    Vue.use(FormCheckboxPlugin);
    Vue.use(DropdownPlugin);
    Vue.use(FormSelectPlugin);
    Vue.use(ToastPlugin);
    Vue.use(FormGroupPlugin);
    Vue.use(FormPlugin);
    Vue.use(FormRadioPlugin);
    Vue.use(SpinnerPlugin);
    Vue.use(NavPlugin);

    Vue.use(Vuelidate);
    Vue.use(VueReCaptcha, { siteKey: wpConfig.recaptcha_site_key });

    Vue.mixin({
      computed: {
        lastSiteUrl() {
          return Cookie.get("jbs_last");
        },
        isTrade() {
          return process.env.JBS_SITEMODE === "trade";
        },
        isStaff() {
          return wpConfig.user ? wpConfig.user.is_staff : false;
        },
        isLoggedIn() {
          return wpConfig.user.is_guest ? false : true;
        }
      },
      methods: {
        populateAddressPlaceholders(address) {
          address = { ...address };
          for (var k in address) {
            if (typeof address[k] === "string") {
              address[k] = address[k].replace("[ACC]", address.Acc);
              address[k] = address[k].replace(
                "[CUSTNAME]",
                this.$store.state.user.customer_name
              ); // TODO: Change this to customer_name, but requires caching of current BP for perf
            }
          }

          return address;
        },
        showLogin() {
          window.dispatchEvent(new CustomEvent("login-modal"));
        },
        showFatal(title, msg, err) {
          window.dispatchEvent(
            new CustomEvent("fatal", { detail: { title, msg, err } })
          );
        },
        showError(title, msg, err) {
          if (err) {
            msg += " (" + err.message + ")";
          }

          return this.$bvModal.msgBoxOk(msg, {
            title,
            modalClass: "modal-error",
            centered: true
          });
        }
      }
    });

    Vue.mixin({
      data() {
        return {
          wpConfig
        };
      }
    });

    Vue.mixin({
      methods: {
        isMobileDevice() {
          return (
            (typeof window.orientation !== "undefined" ||
              navigator.userAgent.indexOf("IEMobile") !== -1) &&
            window.innerWidth < 768
          );
        }
      }
    });

    Vue.prototype.$forceCompute = function (
      computedName,
      forceUpdate /* default: true */
    ) {
      if (this._computedWatchers[computedName]) {
        this._computedWatchers[computedName].run();
        if (forceUpdate || typeof forceUpdate == "undefined")
          this.$forceUpdate();
      }
    };

    Vue.filter("cardExpiryDateFromTimestamp", function (value) {
      var d = new Date(value * 1000);

      return d.toLocaleDateString(undefined, { month: 'short' }) + " " + d.getFullYear();
    })


    Vue.filter("inlineAddress", function (value, no_recipient) {
      var parts = [];

      const field_order = [
        no_recipient ? null : "Recipient",
        "Address1",
        "Address2",
        "Address3",
        "City",
        "Country",
        "PostCode"
      ];

      for (var i in field_order) {
        if (value[field_order[i]]) {
          parts.push(value[field_order[i]]);
        }
      }

      return parts.join(", ");
    });

    Vue.filter("percentage", function (value) {
      return parseFloat(value).toFixed(2) + "%";
    });

    Vue.filter("currency", function (value) {
      if (value < 0) {
        return "-£" + parseFloat(Math.abs(value)).toFixed(2);
      } else {
        return "£" + parseFloat(value).toFixed(2);
      }
    });

    Vue.filter("expireTime", function (value) {
      if (value) {
        var m = Math.floor(value / 60);
        var s = Math.floor(value % 60);
        return "" + m + ":" + s.toString().padStart(2, "0");
      } else {
        return "unknown";
      }
    });

    Vue.filter("currencyWhole", function (value) {
      return "£" + parseFloat(value).toFixed(0);
    });

    Vue.filter("formatDate", function (value) {
      if (value) {
        return moment.unix(value).format("DD/MM/YYYY");
      }
    });

    Vue.filter("formatDatetime", function (value) {
      if (value) {
        return moment(value.date).calendar();
      }
    });

    Vue.filter("inflect", function (value, num) {
      if (!value) return "";

      if (parseInt(num) === 1) {
        return Inflector.singularize(value);
      } else {
        return Inflector.pluralize(value);
      }
    });

    Vue.filter("truncate", function (text, length, clamp) {
      clamp = clamp || "...";
      var node = document.createElement("div");
      node.innerHTML = text;
      var content = node.textContent;
      return content.length > length
        ? content.slice(0, length) + clamp
        : content;
    });

    Vue.filter("resultPrice", function (result) {
      if (typeof result._source !== 'undefined') {
        // We have a ES result

        if (result._source.DutyType === 'DP') {
          if (result._source.StockPackage === 'bottle') {
            return result._source.DP_BottlePrice;
          } else if (result._source.StockPackage === 'case') {
            return result._source.DP_CasePrice;
          }
        } else if (result._source.DutyType === 'IB') {
          return result._source.IB_CasePrice;
        }

      } else {
        // We 'probably' have a normalised object

      }

      return -1;
    });

    Vue.filter("wasPrice", function (result) {
      if (typeof result._source !== 'undefined') {
        // We have a ES result

        if (result._source.DutyType === 'DP') {
          return result._source.DP_Price_Old > 0 ? result._source.DP_Price_Old : false;
        } else if (result._source.DutyType === 'IB') {
          return result._source.IB_Price_Old > 0 ? result._source.IB_Price_Old : false;
        }

      } else {
        // We 'probably' have a normalised object

      }

      return -1;
    });

    Vue.filter("resultPackage", function (result) {
      if (typeof result._source !== 'undefined') {
        // We have a ES result

        if (result._source.DutyType === 'DP') {
          if (result._source.StockPackage === 'bottle') {
            return result._source.BottleSize;
          } else if (result._source.StockPackage === 'case') {
            return result._source.CaseSize;
          }
        } else if (result._source.DutyType === 'IB') {
          return result._source.CaseSize;
        }

      } else {
        // We 'probably' have a normalised object

      }

      return 'Unknown';
    });
  }
};
